<script lang="ts" setup>
import { userData as user } from '@/Support/Users/userData'
import IndividualMembershipBadge from '@/Components/App/Memberships/IndividualMembershipBadge.vue'
import { useAppLayout } from '@/stores/appLayout'

const { openAiQuery } = useAppLayout()
</script>
<template>
  <IndividualMembershipBadge
    :membership="user.has_individual_membership"
    :ai="user.has_ai_individual_membership"
    :vip="user.vip"
    :class="[user.has_ai_individual_membership ? 'cursor-pointer' : '']"
    @click="openAiQuery"
  />
</template>
